module.exports = __webpack_public_path__ + "static/media/fonts-2-mobile.3d0afda4.svg";